import fetchCustomerGroup from '@data/customerGroup/fetchCustomerGroup';
import { useQuery } from '@tanstack/react-query';

const getCustomerGroup = ({ enabled, queries }) => {
    return useQuery({
        queryKey: ['customer-group', queries],
        queryFn: async () => await fetchCustomerGroup({ queries }),
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: enabled,
    });
};

export default getCustomerGroup;
